/* eslint-disable */
import * as React from "react";

import { ReportRenderer, useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { MethodControl } from "../controls/MethodControl";
import { BaseForIndexHierarchyControl } from "../controls/BaseForIndexHierarchy";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  const [mathodValue] = useParameter<number>("@method");
  const isMethodIndex = mathodValue === 2;

  return (
    <>
      <ReportToolbarGroup>
        <MethodControl />
        {isMethodIndex && <BaseForIndexHierarchyControl />}
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </div>
    </>
  );
}
